import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Spin } from "antd";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  apiSubmit: () => void;
  loading: boolean;
}

export default function DeleteAllCompanyPopUp(props: PropsType) {
  const { onClose, apiSubmit, loading } = props;

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper deleteModal">
        <div className="modal_header">
          <div className="title">
            <h3>
              <span>
                <img src="/images/company/warning.svg" alt="warning" />
              </span>
              All companies data will be erased
            </h3>
            <p>
              The companies user accounts, data, and history will be permanently
              deleted. This action cannot be undone.
            </p>

            <p>
              Think twice and consider
              <span
                style={{
                  textDecoration: "underline",
                  paddingLeft: "3px",
                  paddingRight: "3px",
                }}
              >
                deactivating company
              </span>
              instead to preserve its data.
            </p>
          </div>
        </div>

        <div className="modal_content"></div>

        <div className="modal_footer">
          <Button
            htmlType="button"
            type="default"
            size="large"
            className="outlined-btn"
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button
            htmlType="submit"
            type="primary"
            size="large"
            className="danger-btn"
            onClick={apiSubmit}
          >
            Delete All
          </Button>
        </div>
      </div>
    </Spin>
  );
}
